const languages = [{
    code: "nl",
    name: "Nederlands"
}, {
    code: "fr",
    name: "Français"
}, {
    code: "en",
    name: "English"
}];

export {
    languages
};